<template>
  <div class="loading-page">
    <div class="center-logo">
      <img class="logo" :src="require('@/assets/logo.png')" alt="荣大智慧云" />
      <p>可多人协作的在线Office</p>
      <!-- <img class="loading" :src="require('@/assets/loading/loading.gif')" alt="荣大智慧云" /> -->
      <img
        class="loading"
        :src="require('@/assets/loading/loading.png')"
        alt="荣大智慧云"
      />
    </div>
    <div class="bottom-logo">
      <img
        :src="require('@/assets/loading/loading-footer-left.png')"
        alt="WPS"
      />
      <div class="bottom-logo-ri">
        <img :src="require('@/assets/loading/logo-grey.png')" alt="智慧云" />
        <span>智慧云</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style lang="scss" scoped>
.loading-page {
  position: relative;
  z-index: 1;
  width: 100vw;
  height: 100vh;
  background-color: #f1f4f7;
  .center-logo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    height: 300px;
    width: 400px;
    border-radius: 2px;
    background-color: #fff;
    transform: translate(-50%, -50%);
    box-shadow: 0px 2px 7px -2px rgba(0, 0, 0, 0.16);
    img.logo {
      width: 54px;
    }
    img.loading {
      margin-top: 15px;
      animation: imgRotate 1.5s linear infinite;
      @keyframes imgRotate {
        from {
          transform: rotate(0);
        }
        to {
          transform: rotate(360deg);
        }
      }
    }
    p {
      font-size: 18px;
      margin-top: 15px;
    }
  }
  .bottom-logo {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 70px;
    left: 0;
    right: 0;
    img {
      height: 26px;
    }
    &-ri {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 26px;
      img {
        height: 24px;
      }
      span {
        font-size: 16px;
        color: #626f7a;
        padding-left: 5px;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue